<div *ngIf="loading" class="loader">
  <div class="spinner-border" role="status"></div>
</div>
<main class="main">
  <mat-dialog-content>
    <h2 class="main--text">{{ 'createExternDriver' | i18next }}</h2>
  </mat-dialog-content>
  <form [formGroup]="form" class="main--form">
    <mat-form-field class="width-standar">
      <mat-label>{{ 'dni' | i18next }}</mat-label>
      <input
        matInput
        class="content--section__select__input extern"
        formControlName="dni"
        type="text"
      />
    </mat-form-field>
    <mat-form-field class="width-standar">
      <mat-label>{{ 'driverLicense' | i18next }}</mat-label>
      <input
        matInput
        class="content--section__select__input extern"
        formControlName="driverLicense"
        type="text"
      />
    </mat-form-field>
    <mat-form-field class="width-standar">
      <mat-label>{{ 'name' | i18next }}</mat-label>
      <input
        matInput
        class="content--section__select__input extern"
        formControlName="name"
        type="text"
      />
    </mat-form-field>
    <mat-form-field class="width-standar">
      <mat-label>{{ 'surnames' | i18next }}</mat-label>
      <input
        matInput
        class="content--section__select__input extern"
        formControlName="lastName"
        type="text"
      />
    </mat-form-field>
    <mat-form-field class="width-standar">
      <mat-label>{{ 'company' | i18next }}</mat-label>
      <input
        matInput
        class="content--section__select__input extern"
        formControlName="company"
        type="text"
      />
    </mat-form-field>
    <mat-form-field class="width-standar">
      <mat-label>{{ 'address' | i18next }}</mat-label>
      <input
        matInput
        class="content--section__select__input extern"
        formControlName="address"
        type="text"
      />
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{ 'area' | i18next }}</mat-label>
      <mat-select formControlName="area" (selectionChange)="areaChange()">
        <mat-option *ngFor="let area of areas" [value]="area.id">
          {{ area.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{ 'departament' | i18next }}</mat-label>
      <mat-select formControlName="departament" [disabled]="true">
        <mat-option
          *ngFor="let departament of departaments"
          [value]="departament.id"
        >
          {{ departament.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="width-standar">
      <mat-label>{{ 'email' | i18next }}</mat-label>
      <input
        matInput
        class="content--section__select__input extern"
        formControlName="email"
        type="email"
      />
    </mat-form-field>
    <mat-form-field class="width-standar">
      <mat-label>{{ 'phone' | i18next }}</mat-label>
      <input
        matInput
        class="content--section__select__input extern"
        formControlName="telephone"
        type="text"
        placeholder="{{ 'phone' | i18next }}"
      />
    </mat-form-field>
  </form>
  <mat-dialog-actions>
    <div class="btn-container">
      <button type="button" class="btn btn-cancel" mat-dialog-close>
        {{ 'altCancel' | i18next | uppercase }}
      </button>
      <button
        type="submit"
        class="btn"
        (click)="submitRequest()"
        [disabled]="form.invalid"
      >
        {{ 'stepConfirm' | i18next | uppercase }}
      </button>
    </div>
  </mat-dialog-actions>
</main>
